import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import { appendWistiaScriptIfMissing, addVideoToQueue } from './wistiaSdk';

const WistiaVideoPlayer = ({ options, videoId, onLoaded }) => {
  useEffect(() => {
    appendWistiaScriptIfMissing();
  }, []);

  useEffect(() => {
    let videoHandle;

    if (videoId) {
      addVideoToQueue({
        id: videoId,
        options,
        onEmbedded: video => {
          videoHandle = video;
        },
      });
    }

    return () => {
      if (videoHandle) {
        videoHandle.remove();
      }
    };
  }, [videoId, options]);

  useEffect(() => {
    if (!window._wq) {
      return;
    }
    window._wq.push({ id: videoId, onReady: onLoaded });
  }, [onLoaded, videoId]);

  return (
    <div
      className={`m-0 wistia_embed wistia_async_ ${videoId} videoFoam=true`}
      key={videoId}
    />
  );
};

WistiaVideoPlayer.propTypes = {
  options: PropTypes.object,
  videoId: PropTypes.string.isRequired,
  onLoaded: PropTypes.func,
};

export default WistiaVideoPlayer;
